import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
  TextField,
  FormControl,
  Radio,
  OutlinedInput,
  Icon,
  InputAdornment,
  Checkbox,
  Input,
  Switch
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';

import { makeStyles, styled } from "@mui/styles";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
// import DesktopTimePicker from '@mui/lab/DesktopTimePicker';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker, TimePicker, DesktopDatePicker, DesktopTimePicker, LocalizationProvider } from '@mui/x-date-pickers';

import dayjs from "dayjs";
import * as Util from "../../../../services/global.service";

import {
  getTagsList,
  postCreateAnnouncement,
  putUpdateAnnouncement,
  getAnnouncementDetail
} from "../../../../actions/manageAnnouncement";

import SimpleDialog from "../../../../components/SimpleDialog";
import AlertDialog from "../../../../components/AlertDialog";
import WarningDialog from "../../../../components/WarningConfirm";
import InputTags from "../../../../components/manageAnnouncement/InputTags";

import { ReactComponent as Clock } from "../../../../icons/clock.svg";
import { ReactComponent as Calendar } from "../../../../icons/calendar.svg";
import { ReactComponent as CheckedGreen } from "../../../../icons/checked-green.svg";
import defaultBanner from "../../../../assets/images/announcement/default.jpg"

// import axios from "axios";
const AnnouncementForm = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _ = require("lodash");
  const navigate = useNavigate();
  let { serial } = useParams();

  const useStyles = makeStyles({
    closeSvg: {
      "& > path": {
        fill: "#5DA196",
      },
      "& g > path": {
        fill: "#5DA196",
      },
    },
    customTextField: {
      "& input::placeholder": {
        fontSize: "16px",
        color: "#A3A3A3",
      },
    },
    disabled: {
      background: "#F3F3F3!important",
    },
    error: {
      color: " #CC6058 !important",
    },
    tagsSearchRoot: {
      cursor: "pointer",
      webkitTransition: "background-color 0.1s linear!important",
      mozTransition: "background-color 0.1s linear!important",
      oTransition: "background-color 0.1s linear!important",
      msTransition: "background-color 0.1s linear!important",
      transition: "background-color 0.1s linear!important",
      borderRadius: "0px!important",
      backgroundColor: "#FFF",
      width: "100%",
      height: "40px",
      margin: "0",
      padding: "0 15px",
      display: "flex",
      alignItems: "center",
      '&:hover': {
        backgroundColor: '#E7F1EF'
      }
    },
    desktopView: {
      "& .MuiPaper-root": {
        width: "584px",
      },
      "& .PrivatePickersToolbar-root": {
        maxWidth: "unset",
        width: "270px",
        padding: "16px 24px",
      },
      "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-separator": {
        width: "24px",
        padding: "16px 0",
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "56px",
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.87)"
      },
      "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root": {
        width: "96px",
        padding: "16px 0",
        fontSize: "48px",
        fontWeight: "500",
        lineHeight: "56px",
        textAlign: "center",
        background: "rgba(33, 33, 33, 0.08)",
        borderRadius: "4px",
        color: "rgba(0, 0, 0, 0.87)"
      },
      "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root.Mui-selected": {
        background: "rgba(93, 161, 150, 0.15)",
        color: "#5DA196"
      },
      "& .PrivateTimePickerToolbar-ampmSelection": {
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "4px",
      },
      "& .PrivateTimePickerToolbar-ampmSelection button:first-child": {
        borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "0",
      },
      "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root": {
        fontSize: "20px",
        padding: "8px 0",
        fontWeight: "500",
        lineHeight: "24px",
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.87)"
      },
      "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root.Mui-selected": {
        color: "#5DA196",
        background: "rgba(93, 161, 150, 0.15)",
        width: "100%",
      },
      "& .MuiClockPicker-arrowSwitcher": {
        visibility: "hidden"
      },
      "& div > div > div >  .MuiButtonBase-root": {
        visibility: "hidden"
      },
      "& div > .PrivateTimePickerToolbar-hourMinuteLabel > button": {
        visibility: "unset !important"
      },
      "& div > .PrivateTimePickerToolbar-ampmSelection > button": {
        visibility: "unset !important",
        width: "50%",
      },
    }
  });

  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" {...props} />
  ))(({ theme }) => ({
    width: "50px !important",
    height: "24px !important",
    padding: "0 !important",
    marginRight: "10px",
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: "4px 6px",
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 1,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 1,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 16,
      height: 16,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }))

  const classes = useStyles()

  // Function Start
  const goto = (path, data) => {
    if (data) {
      navigate("/admin" + path, { replace: false, state: data })
    } else {
      navigate("/admin" + path, { state: data })
    }
  }
  const handleSuccessCreate = (val) => {
    openSuccessCreateOpen(false)
    goto("/announcement");
  }

  const requireField = (text) => {
    return (
      <Grid container direction="row">
        <Grid>
          <Typography
            style={{ fontSize: "18px", color: "#404349", fontWeight: "500" }}
          >
            {text}
          </Typography>
        </Grid>
        <Grid>
          <Typography
            style={{ color: "#cc6058", fontSize: "18px", fontWeight: 500 }}
          >
            &nbsp;*
          </Typography>
        </Grid>
      </Grid>
    )
  }

  const warningMessage = (bool, text) => {
    return (
      bool && (
        <Grid container direction="row">
          <Grid>
            <Typography
              style={{
                fontSize: "14px",
                color: "#CC6058",
                fontWeight: "500",
                fontFamily: "Kanit",
              }}
            >
              {text ? text : t("admin.announcement.form.warningFill")}
            </Typography>
          </Grid>
        </Grid>
      )
    )
  }

  const handleConfirmCancel = (val) => {
    openCancelDialog(false)
    goto("/announcement")
  }

  const handleConfirmCancelDialog = (val) => {
    openCancelDialog(val)
  }
  // Varify & Set Data End
  // Function End

  // Variable Start
  const [topic, setTopic] = React.useState("")
  const [subTopic, setSubTopic] = React.useState("")
  const [isCancelDialogOpen, openCancelDialog] = React.useState(false)
  const [isSuccessCreateOpen, openSuccessCreateOpen] = React.useState(false)
  // Variable End

  const [file, setFile] = React.useState()
  const [previewFile, setPreviewFile] = React.useState()
  const [isFileValid, setIsFileValid] = React.useState()
  const [isRemoveThumbnail, setIsRemoveThumbnail] = React.useState(false)
  const [isImageInvalidDialogOpen, setIsImageInvalidDialogOpen] = React.useState(false)
  useEffect(() => {
    if (typeof file === "string") {
      setPreviewFile(file)
    } else {
      validateFile()
      if (!file) {
        setPreviewFile(undefined)
        return
      }
      // create the preview
      const objectUrl = URL.createObjectURL(file)
      setPreviewFile(objectUrl)
      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl)
    }
  }, [file])

  const handleRemoveFile = React.useCallback((e) => {
    setIsRemoveThumbnail(true)
    e.stopPropagation();
    e.preventDefault();
    setFile(undefined)
  }, []);

  const inputRef = useRef(null);
  const handleClickFileInput = () => {
    inputRef.current.click();
  };
  const fileChangedHandler = e => {
    if (!e.target.files || e.target.files.length === 0) {
      setFile(undefined)
      return
    }
    setFile(e.target.files[0])
    setIsRemoveThumbnail(false)
  }

  const validateFile = () => {
    if (file) {
      if ((file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") && file.size <= 2 * 1024 * 1024) {
        setIsFileValid(true)
      } else {
        setFile(undefined)
        setIsImageInvalidDialogOpen(true)
        setIsFileValid(false)
      }
    } else {
      setIsFileValid(false)
    }
  }

  const [content, setContent] = React.useState("")
  const handleContent = (content) => {
    setContent(content)
  }
  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'color': [] }, { 'background': [] }],
      ['clean']
    ],
  }
  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "color",
    "background"
  ]

  const [tags, setTags] = React.useState([])
  const [searchTags, setSearchTags] = React.useState("")
  const [isResetTagsInput, setIsResetTagsInput] = React.useState(false)
  const [tagsList, setTagsList] = React.useState([])
  const [filteredTagsList, setFilteredTagsList] = React.useState([])
  const addTagFromList = (tag) => {
    let tmpTags = [...tags]
    tmpTags.push(tag)
    tmpTags = [...new Set(tmpTags)];
    setTags(tmpTags)
    setIsResetTagsInput(true)
    setSearchTags("")
  }

  useEffect(() => {
    let result = [];
    if (searchTags !== "") {
      result = tagsList.filter((item) => {
        return Object.keys(item).some((key) => {
          if (item[key]) {
            return item[key].toString().toLowerCase().indexOf(searchTags.toLowerCase()) !== -1;
          }
          return item[key];
        });
      });
    } else {
      result = tagsList;
    }
    setFilteredTagsList(result)
  }, [searchTags, tagsList])

  const [mode, setMode] = React.useState("")

  useEffect(() => {
    dispatch(getTagsList()).then(resp => {
      if (resp?.data?.tags) {
        setTagsList(resp.data.tags)
        setFilteredTagsList(resp.data.tags)
      }
    })

    if (serial && serial !== "") {
      setMode("edit")
    }
  }, [])


  useEffect(() => {
    if (serial && serial !== "" && mode === "edit") {
      dispatch(getAnnouncementDetail(serial)).then(resp => {
        if (resp?.data) {
          let data = resp.data
          // removeSubStringFromString(data.title)
          //console.log(data.title.length)
          setTopic(data.title)
          setSubTopic(data.excerpt)
          setContent(data.description)
          if (data?.thumbnail && data?.thumbnail !== "") setFile(data.thumbnail)
          setTags(data.tags)


          setStartDate(data.start_at)
          setTimeStartDate(data.start_at)
          if (data?.end_at && data?.end_at !== "" && data.end_at !== "0001-01-01T00:00:00Z") {
            setEndDate(data.end_at)
            setTimeEndDate(data.end_at)
          }
          setRecommended(data.show_home ? true : false)
          setStatus(data.status === "active" ? true : false)
        }
      })
    }
  }, [mode])


  const handleTagsCharUpdate = (val) => {
    setSearchTags(val)
  }

  // start date , end date
  const [timeStartDate, setTimeStartDate] = React.useState(new Date())
  const [startDate, setStartDate] = React.useState(new Date())
  const handleChangeStartDateTime = (val) => {
    setTimeStartDate(val)
  }
  const handleChangeStartDate = (val) => {
    setStartDate(Util.formatDate(val))
  }
  const [isStartDatePickerOpen, setIsStartDatePickerOpen] = React.useState(false)
  const handleOpenStartDatePicker = (val) => {
    console.log('handleOpenStartDatePicker', val)
    setIsStartDatePickerOpen(val)
  }
  const [isStartTimePickerOpen, setIsStartTimePickerOpen] = React.useState(false)
  const handleOpenStartTimePicker = (val) => {
    setIsStartTimePickerOpen(val)
  }

  // let timeEndDateOffset = new Date()
  // timeEndDateOffset.setMinutes(timeEndDateOffset.getMinutes() + 1)
  // timeEndDateOffset = new Date(timeEndDateOffset)
  const [timeEndDate, setTimeEndDate] = React.useState(null)
  const [endDate, setEndDate] = React.useState(null)
  const handleChangeEndDateTime = (val) => {
    setTimeEndDate(val)
  }
  const handleChangeEndDate = (val) => {
    setEndDate(Util.formatDate(val))
  }
  const [isEndDatePickerOpen, setIsEndDatePickerOpen] = React.useState(false)
  const handleOpenEndDatePicker = (val) => {
    setIsEndDatePickerOpen(val)
  }
  const [isEndTimePickerOpen, setIsEndTimePickerOpen] = React.useState(false)
  const handleOpenEndTimePicker = (val) => {
    setIsEndTimePickerOpen(val)
  }
  const [minEndDate, setMinEndDate] = React.useState(new Date())
  const [minStartDate, setMinStartDate] = React.useState(new Date(2010, 1, 1))
  const [maxStartDate, setMaxStartDate] = React.useState(new Date(2099, 12, 12))
  // set min date & max date
  const [maxStartTime, setMaxStartTime] = React.useState()
  const [minEndTime, setMinEndTime] = React.useState(new Date())
  // set min start time & max end time 
  useEffect(() => {
    const date = new Date(startDate);
    const time = new Date(timeStartDate);
    let newDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds())
    newDateTime.setMinutes(newDateTime.getMinutes() + 1); // timestamp
    newDateTime = new Date(newDateTime); // Date object
    setMinEndDate(newDateTime)
    setMinEndTime(newDateTime)
  }, [startDate, timeStartDate])
  useEffect(() => {
    if (endDate && timeEndDate) {
      const date = new Date(endDate);
      const time = new Date(timeEndDate);
      let newDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds())
      newDateTime.setMinutes(newDateTime.getMinutes() - 1); // timestamp
      newDateTime = new Date(newDateTime); // Date object
      setMaxStartDate(newDateTime)
      setMaxStartTime(newDateTime)
    }
  }, [endDate, timeEndDate])

  const [recommended, setRecommended] = React.useState(true)
  const [status, setStatus] = React.useState(true)

  const [validateField, setValidateField] = React.useState()


  const handleSubmitForm = () => {
    let isValid = validateForm()

    if (isValid) {
      let startDateFormat = moment(startDate).format("YYYY-MM-DD")
      let startTimeFormat = moment(timeStartDate).format("HH:mm:ss")
      let tmpFormData = new FormData()
      let tmpTags = tags.join(",")
      tmpFormData.append("title", topic)
      tmpFormData.append("excerpt", subTopic)
      tmpFormData.append("description", content)
      tmpFormData.append("tags", tmpTags)
      tmpFormData.append("startDate", startDateFormat)
      tmpFormData.append("startTime", startTimeFormat)
      tmpFormData.append("showHome", recommended ? "y" : "n")
      tmpFormData.append("isActive", status ? "y" : "n")
      tmpFormData.append("removeThumbnail", isRemoveThumbnail ? "y" : "n")

      if (!isEmpty(endDate) && !isEmpty(timeEndDate)) {
        if (!(new Date(endDate) <= new Date(1970, 1, 1))) {
          let endDateFormat = moment(endDate).format("YYYY-MM-DD")
          let endTimeFormat = moment(timeEndDate).format("HH:mm:ss")
          tmpFormData.append("endDate", endDateFormat)
          tmpFormData.append("endTime", endTimeFormat)
        } else {
          tmpFormData.append("endDate", "")
          tmpFormData.append("endTime", "")
        }
      }

      if (file) {
        tmpFormData.append("thumbnail", file)
      }

      if (mode !== "edit") {
        dispatch(postCreateAnnouncement(tmpFormData)).then(resp => {
          if (resp?.success) {
            openSuccessCreateOpen(true)
          }
        })
      } else {
        dispatch(putUpdateAnnouncement(tmpFormData, serial)).then(resp => {
          if (resp?.success) {
            openSuccessCreateOpen(true)
          }
        })
      }
    }
  }

  const isEmpty = (data) => {
    if (data == null || data == "" || data.length == 0 || !data) {
      return true
    } else
      return false
  }

  const removeSubStringFromString = (string) => {
    let newString = string.replace("\r\n", "")
    return newString
  }

  const validateForm = () => {
    var data = {}
    let result = true
    if (isEmpty(topic) || removeSubStringFromString(topic).length > 180) {
      data = Object.assign(data, { topic: true })
      result = false
    }
    if (removeSubStringFromString(subTopic).length > 180) {
      data = Object.assign(data, { subTopic: true })
    }
    if (isEmpty(content) || content === "<p><br></p>") {
      data = Object.assign(data, { content: true })
      result = false
    }
    if ((isEmpty(startDate) || startDate <= "2010-01-01")) {
      data = Object.assign(data, { startDate: true })
      result = false
    }
    if (isEmpty(timeStartDate)) {
      data = Object.assign(data, { timeStartDate: true })
      result = false
    }
    if ((!isEmpty(endDate) && isEmpty(timeEndDate)) || ((isEmpty(endDate) || endDate <= "2010-01-01") && !isEmpty(timeEndDate))) {
      data = Object.assign(data, { timeEndDate: true })
      // return false
    }
    console.log(data)
    setValidateField(data)
    return result
  }

  const handleCancelForm = () => {
    openCancelDialog(true)
  }


  return (
    <>
      <Helmet>
        <title>Admin - Announcement | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container mb={3}>
            <Grid item>
              <Typography fontSize={18} fontWeight="400" color="#A3A3A3">
                {mode !== "edit" ? t("admin.announcement.createAnnouncement") : t("admin.announcement.editAnnouncement")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item>
              <Typography fontSize={36} fontWeight="600" color="#404349">
                {mode !== "edit" ? t("admin.announcement.createAnnouncement") : t("admin.announcement.editAnnouncement")}
              </Typography>
            </Grid>
          </Grid>
          <Paper
            sx={{
              mt: 2,
              p: "22px",
              background: "#fff",
              boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
            }}
            mt={3}
          >
            <Grid container display="flex" alignItems="center" mb={1}>
              <Grid
                lg={10} xs={10}
                item
                display="flex"
                alignItems="center">
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {requireField(t("admin.announcement.form.topic"))}
                </Typography>
              </Grid>
              <Grid
                item
                ml="auto"
                display="flex"
                alignItems="center"
              >
                <Typography fontSize="14px" fontWeight="400" color={topic.length === 0 ? "#D8D8D8" : removeSubStringFromString(topic).length <= 180 ? "#5DA196" : "#CC6058"}>{removeSubStringFromString(topic).length ?? 0}/180</Typography>
              </Grid>
            </Grid>
            <Grid container mb={3}>
              <Grid
                lg={12}
                item
              >
                <TextField
                  multiline
                  fullWidth
                  minRows={2}
                  maxRows={6}
                  error={validateField?.topic ?? false}
                  onChange={(e) => setTopic(e.target.value)}
                  id="outlined-basic"
                  placeholder={t("admin.announcement.form.fillTopic")}
                  value={topic}
                  variant="outlined"
                  required
                  size="small"
                  sx={{
                    WebkitTextFillColor: !topic ? "#AAAAAA" : "#404349",
                    fontWeight: !topic ? "300" : "400",
                    fontSize: "16px",
                    resize: "none",
                    borderColor: validateField?.topic ? "#CC6058" : "#e1e1e1",
                  }}
                />
                {validateField?.topic &&
                  !topic &&
                  warningMessage(validateField.topic)}
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid lg={10} xs={10} item>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("admin.announcement.form.subTopic")}
                </Typography>
              </Grid>
              <Grid
                item
                ml="auto"
                display="flex"
                alignItems="center"
              >
                <Typography fontSize="14px" fontWeight="400" color={subTopic.length === 0 ? "#D8D8D8" : removeSubStringFromString(subTopic).length <= 180 ? "#5DA196" : "#CC6058"}>{removeSubStringFromString(subTopic).length ?? 0}/180</Typography>
              </Grid>
            </Grid>
            <Grid container mb={3}>
              <Grid
                lg={12}
                item
                style={{ my: 1 }}
              >
                <TextField
                  multiline
                  fullWidth
                  minRows={2}
                  maxRows={6}
                  placeholder={t("admin.announcement.form.fillSubTopic")}
                  variant="outlined"
                  required
                  size="small"
                  sx={{
                    WebkitTextFillColor: !subTopic ? "#AAAAAA" : "#404349",
                    fontWeight: !subTopic ? "300" : "400",
                    fontSize: "16px",
                    resize: "none",
                    borderColor: validateField?.subTopic ? "#CC6058" : "#e1e1e1",
                  }}
                  value={subTopic}
                  onChange={(e) => setSubTopic(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid item>
                <Typography fontSize="18px" color="#404349" fontWeight="500">
                  {t("admin.announcement.form.banner")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mb={0.5}>
              <Grid
                item
                xs={12}
                sm={2.5}
                md={2.5}
                lg={2.5}
                xl={2.5}
              >
                <img src={previewFile ? previewFile : defaultBanner} alt="Default Banner" style={{ width: "263px", height: "175px" }} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={7.5}
                md={7.5}
                lg={7.5}
                xl={7.5}
              >
                <Grid container>
                  <Grid item>
                    <Typography color="#AAAAAA" fontSize="14px" fontWeight="300">
                      {t("admin.announcement.form.useDefaultBanner")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mb={1}>
                  <Grid item>
                    <Typography color="#404349" fontSize="18px" fontWeight="400">
                      {t("admin.announcement.form.uploadYourBanner")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mb={1}>
                  <Grid item display="flex" alignItems="center">
                    <Box sx={{ display: "flex", flexDirection: "row", cursor: "pointer", mr: 2 }} onClick={handleClickFileInput}>
                      <Box sx={{ width: "396px", height: "36px", borderRadius: "4px 0px 0px 4px", border: "1px solid #CED4DA", display: "flex", alignItems: "center", justifyContent: "start" }} >
                        <Typography fontSize="16px" color={(file && file?.name) || typeof file === "string" ? "#404349" : "#AAAAAA"} fontWeight="300" sx={{ pl: 1, cursor: "pointer", textOverflow: "ellipsis", width: "370px" }}> {file && file?.name ? file.name : typeof file === "string" ? "Banner" : t("admin.announcement.form.chooseFile")} </Typography>
                        {((file && file?.name) || typeof file === "string") && (<Typography sx={{ ml: "auto", mr: 1.5 }} color="#404349" onClick={(e) => handleRemoveFile(e)}>X</Typography>)}
                      </Box>
                      <Box sx={{ width: "75px", height: "36px", borderRadius: "0px 4px 4px 0px", borderLeft: "none!important", border: "1px solid #CED4DA", background: "#E9ECEF", boxShadow: "-1px 0px 0px #CED4DA", display: "flex", alignItems: "center", justifyContent: "center" }} >
                        <Typography fontSize="16px" color="#404349" fontWeight="300" sx={{ cursor: "pointer" }}> {t("admin.announcement.form.browse")} </Typography>
                      </Box>
                      <input
                        type="file"
                        hidden
                        ref={inputRef}
                        onChange={fileChangedHandler}
                      />
                    </Box>
                    {isFileValid && <CheckedGreen />}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Typography color="#AAAAAA" fontSize="14px" fontWeight="300">
                      {t("admin.announcement.form.supportedFormat")} : jpg, jpeg, png
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Typography color="#AAAAAA" fontSize="14px" fontWeight="300">
                      {t("admin.announcement.form.maximumFileSize")}: 2 MB
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item>
                    <Typography color="#AAAAAA" fontSize="14px" fontWeight="300">
                      {t("admin.announcement.form.recommendedSize")} : 500 x 258 pixel
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container mb={2}>
              <Grid item display="flex" alignItems="center" justifyContent="center" sx={{ width: "263px" }}>
                <Typography fontSize="18px" fontWeight="400" color="#404349">
                  {t("admin.announcement.form.previewPicture")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid item>
                <Typography>
                  {requireField(t("admin.announcement.form.content"))}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mb={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ height: "422px" }}>
                {/* <Box sx={{ height: "100%", border: validateField?.content ? "1px solid #CC6058" : "none", borderColor: validateField?.content ? "#CC6058" : "none", borderRadius: "8px" }}> */}
                <ReactQuill theme="snow" value={content} onChange={handleContent} formats={quillFormats} modules={quillModules} style={{ height: "100%", borderRadius: "8px", border: validateField?.content ? "1px solid #CC6058" : "1px solid #CED4DA" }} />
                {/* </Box> */}
                {validateField?.content &&
                  warningMessage(validateField.content)}
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid item display="flex">
                <Typography fontSize="18px" color="#404349" fontWeight="500">
                  {t("admin.announcement.form.addTags")}
                </Typography>
                <Typography fontSize="16px" color="#939393" fontWeight="300" sx={{ ml: 2, fontStyle: "italic" }}>
                  ({t("admin.announcement.form.addTagsDesc")})
                </Typography>
              </Grid>
            </Grid>
            <Grid container mb={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box sx={{ p: 2, border: "1px solid #D4D9DE", borderRadius: "4px" }}>
                  <Box sx={{ position: "relative" }}>
                    <InputTags value={tags} setValue={setTags} onCharChange={handleTagsCharUpdate} resetInput={isResetTagsInput} setResetInput={setIsResetTagsInput} />
                    {(filteredTagsList?.length > 0 && searchTags !== "" && searchTags !== " ") &&
                      <Box sx={{ zIndex: 10, width: "100%", maxHeight: "250px", overflow: "auto", py: 1, border: "1px solid #CED4DA", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", borderRadius: "8px", position: "absolute", mt: 1, background: "#FFF", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        {filteredTagsList?.length > 0 ?
                          filteredTagsList.map(list => {
                            return (
                              <Paper elevation={0} classes={{ root: classes.tagsSearchRoot }} onClick={() => addTagFromList(list)}>
                                <Typography fontSize="16px" fontWeight="400" color="#404349">{list}</Typography>
                              </Paper>
                            )
                          })
                          : <></>
                        }
                      </Box>
                    }
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid item xs={12} sm={5.5} md={5.5} lg={5.5} xl={5.5}>
                <Typography>
                  {requireField(t("admin.announcement.form.startDate"))}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
              </Grid>
              <Grid item xs={12} sm={5.5} md={5.5} lg={5.5} xl={5.5} display="flex">
                <Typography fontSize="18px" color="#404349" fontWeight="500">
                  {t("admin.announcement.form.endDate")}
                </Typography>
                <Typography fontSize="16px" color="#939393" fontWeight="300" sx={{ ml: 2, fontStyle: "italic" }}>
                  ({t("admin.announcement.form.optional")})
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} sm={2.75} md={2.75} lg={2.75} xl={2.75}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    components={{
                      OpenPickerIcon: Calendar
                    }}
                    format="dd/MM/yyyy"
                    value={startDate}
                    minDate={minStartDate}
                    maxDate={maxStartDate}
                    onChange={(value) => handleChangeStartDate(value)}
                    inputProps={{
                      placeholder: t("admin.announcement.form.selectDate"),
                      sx: {
                        "&::placeholder": {
                          color: "#AAAAAA"
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      size="small"
                      error={validateField?.startDate && !startDate}
                      sx={{ "& > div > input": { color: '#404349' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end"> <Calendar /></InputAdornment>,
                      }}
                    />
                    }
                  />
                </LocalizationProvider>
                {validateField?.startDate &&
                  !startDate &&
                  warningMessage(validateField.startDate)}
              </Grid>
              <Grid item xs={12} sm={2.75} md={2.75} lg={2.75} xl={2.75}>
                <LocalizationProvider dateAdapter={AdapterDateFns} >
                  <TimePicker
                    ampm
                    showToolbar={true}
                    orientation="landscape"
                    value={timeStartDate}
                    maxTime={maxStartTime}
                    onChange={(newValue) => handleChangeStartDateTime(newValue)}
                    InputProps={{ sx: { "& .MuiSvgIcon-root": { color: "blue" }, placeholder: t("admin.announcement.form.selectTime") } }}
                    PopperProps={{
                      className: classes.desktopView
                    }}
                    renderInput={(params) => <TextField {...params}
                      sx={{ "& > div > input": { textTransform: "uppercase", color: '#404349' } }}
                      fullWidth
                      size="small"
                      error={validateField?.timeStartDate && !timeStartDate}
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <Clock />
                        </InputAdornment>,
                      }}
                    />}
                  />
                </LocalizationProvider>
                {validateField?.timeStartDate &&
                  !timeStartDate &&
                  warningMessage(validateField.timeStartDate)}
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1} xl={1} display="flex" justifyContent="center" alignItems="center">
                <Typography color="#AAAAAA" fontSize="14px" fontWeight="300">{t("label.to")}</Typography>
              </Grid>
              <Grid item xs={12} sm={2.75} md={2.75} lg={2.75} xl={2.75} sx={{ pl: "6px!important" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>

                  <DatePicker
                    components={{
                      OpenPickerIcon: Calendar
                    }}
                    format="dd/MM/yyyy"
                    value={endDate}
                    minDate={minEndDate}
                    onChange={(value) => handleChangeEndDate(value)}
                    inputProps={{
                      placeholder: t("admin.announcement.form.selectDate"),
                      sx: {
                        "&::placeholder": {
                          color: "#AAAAAA"
                        }
                      }
                    }}
                    renderInput={(params) => <TextField {...params}
                      fullWidth
                      size="small"
                      sx={{ "& > div > input": { color: '#404349' } }}
                      InputProps={{
                        endAdornment: <InputAdornment position="end"> <Calendar /></InputAdornment>,
                      }}
                    />
                    }
                  />

                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={2.75} md={2.75} lg={2.75} xl={2.75}>
                <LocalizationProvider dateAdapter={AdapterDateFns} >
                  <TimePicker
                    ampm
                    showToolbar={true}
                    orientation="landscape"
                    value={timeEndDate}
                    onChange={(newValue) => handleChangeEndDateTime(newValue)}
                    InputProps={{ sx: { "& .MuiSvgIcon-root": { color: "blue" }, placeholder: t("admin.announcement.form.selectTime") } }}
                    PopperProps={{
                      className: classes.desktopView
                    }}
                    renderInput={(params) => <TextField {...params}
                      sx={{ "& > div > input": { textTransform: "uppercase", color: '#404349' } }}
                      fullWidth
                      size="small"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <Clock />
                        </InputAdornment>,
                      }}
                    />}
                  />

                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container mb={1}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Typography>
                  {requireField(t("admin.announcement.form.recommendedAnnouncement"))}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <Typography>
                  {requireField(t("admin.announcement.form.status"))}
                </Typography>
              </Grid>
            </Grid>
            <Grid container mb={3}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} display="flex">
                <IOSSwitch checked={recommended} onChange={() => setRecommended(!recommended)} />
                <Typography fontSize="16px" fontWeight="400" color="#404349">{t("admin.announcement.form.recommended")}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6} display="flex">
                <IOSSwitch checked={status} onChange={() => setStatus(!status)} />
                <Typography fontSize="16px" fontWeight="400" color="#404349">{status ? t("admin.announcement.form.active") : t("admin.announcement.form.inactive")}</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item ml="auto" display="flex">
                <Button
                  size="small"
                  aria-controls="cancel"
                  aria-haspopup="true"
                  onClick={handleCancelForm}
                  color="black"
                  variant="outlined"
                  sx={{ width: "129px", height: "45px", p: "0", textTransform: "none" }}
                >
                  <Typography fontWeight="500" fontSize={18} lineHeight="26.91px">
                    {t("label.cancel")}
                  </Typography>
                </Button>
                <Button
                  size="small"
                  aria-controls="create"
                  aria-haspopup="true"
                  onClick={handleSubmitForm}
                  color="primary"
                  variant="contained"
                  sx={{ width: "129px", height: "45px", p: "0", textTransform: "none", ml: 3 }}
                >
                  <Typography fontWeight="500" fontSize={18} lineHeight="26.91px">
                    {mode !== "edit" ? t("label.create") : t("label.save")}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          </Paper>
          <WarningDialog
            open={isCancelDialogOpen}
            doConfirm={handleConfirmCancel}
            setValue={handleConfirmCancelDialog}
            title={t("admin.announcement.dialog.discardTitle")}
            text={t("admin.announcement.dialog.discardText")}
          />
          <SimpleDialog
            open={isSuccessCreateOpen}
            setValue={handleSuccessCreate}
            text={mode !== "edit" ? t("admin.announcement.dialog.createSuccess") : t("admin.announcement.dialog.editSuccess")}
            title={t("label.success")}
          />
          <AlertDialog
            open={isImageInvalidDialogOpen}
            title={t("admin.announcement.bannerInvalid")}
            message={t("admin.announcement.bannerInvalidDesc")}
            type={"error"}
            close={setIsImageInvalidDialogOpen}
            color="#CC6058"
          />
        </Container>
      </Box>
    </>
  );
};
export default AnnouncementForm;
